import { FC } from 'react';

import Stack from '@mui/material/Stack';
import Section from 'components/Section';
import TextField from 'components/TextField';

const GeneralSettingsEditFormSeo: FC = () => (
  <Section id="seo" title="Seo nustatymai">
    <Stack spacing={4}>
      <TextField
        fullWidth
        name="seoHomeTitle"
        label="Titulinio puslapio title"
      />

      <TextField
        fullWidth
        name="seoHomeMetaDescription"
        label="Titulinio puslapio meta desription"
      />

      <TextField fullWidth name="titleSuffix" label="<title> tekstų priesaga" />
      <TextField fullWidth name="tripsMetaTitle" label="Kelionių <title>" />

      <TextField
        fullWidth
        name="tripsMetaDescription"
        label="Kelionių <meta description>"
      />

      <TextField fullWidth name="tripsH1" label="Kelionių H1" />
    </Stack>
  </Section>
);

export default GeneralSettingsEditFormSeo;
